import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaPedidoNaoLiberadoViewModule } from '../nao-liberado-view';
import { CampanhaPedidoLiberarComponent } from './campanha-pedido-liberar.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaPedidoNaoLiberadoViewModule
    ],
    declarations: [
        CampanhaPedidoLiberarComponent
    ],
    exports: [
        CampanhaPedidoLiberarComponent
    ]
})
export class CampanhaPedidoLiberarModule { }
